
import { defineComponent, ref, toRef } from "vue"
import Swal from "sweetalert2/dist/sweetalert2.js"
import { hideModal } from "@/core/helpers/dom"
import * as Yup from "yup"

import { useStore } from "vuex"
import { Actions } from "@/store/enums/StoreEnums"
import type { ElForm } from "element-plus"

type FormInstance = InstanceType<typeof ElForm>

export default defineComponent({
  name: "new-balance-modal",
  components: {},
  props: [
    'member_id',
    'add_balance'
  ],
  setup(props) {
    const formRef = ref<FormInstance>()
    const store = useStore()
    const newBalanceModalRef = ref<null | HTMLElement>(null)
    const balance = ref(1)

    const onSubmit = (formEl: FormInstance | undefined) => {
      props.add_balance(props.member_id, balance.value)
      balance.value = 1
      hideModal(newBalanceModalRef.value)
    }

    const onCancel = () => {
      hideModal(newBalanceModalRef.value);
    }

    return {
      newBalanceModalRef,
      onSubmit,
      formRef,
      onCancel,
      balance
    }
  },
})
